/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AdminSystemConfigurationBodyDTO } from '../model/models';
import { ElsterConfigurationDTO } from '../model/models';
import { SystemConfigurationDTO } from '../model/models';
import { TenantBodyDTO } from '../model/models';
import { TenantDTO } from '../model/models';
import { TenantGroupEnumDTO } from '../model/models';
import { TenantStatusDTO } from '../model/models';
import { TenantStatusEnumDTO } from '../model/models';
import { TenantTypeEnumDTO } from '../model/models';
import { TenantsResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTenantRequestParams {
    tenantBodyDTO: TenantBodyDTO;
}

export class ClsCreateTenantRequestParams {
    tenantBodyDTO: TenantBodyDTO = undefined;
}

export interface GetTenantRequestParams {
    tenantId: string;
}

export class ClsGetTenantRequestParams {
    tenantId: string = undefined;
}

export interface GetTenantElsterConfigRequestParams {
    tenantId: string;
}

export class ClsGetTenantElsterConfigRequestParams {
    tenantId: string = undefined;
}

export interface GetTenantTenantsRequestParams {
    tenantId: string;
    search?: Array<string>;
    pageSize?: number;
    pageNumber?: number;
    sort?: string;
}

export class ClsGetTenantTenantsRequestParams {
    tenantId: string = undefined;
    search?: Array<string> = undefined;
    pageSize?: number = undefined;
    pageNumber?: number = undefined;
    sort?: string = undefined;
}

export interface GetTenantsRequestParams {
    filter?: string;
    search?: Array<string>;
    type?: Array<TenantTypeEnumDTO>;
    status?: Array<TenantStatusEnumDTO>;
    tenantGroup?: Array<TenantGroupEnumDTO>;
    tenantIds?: Array<string>;
    customerIdentifier?: string;
    requiredTenantId?: string;
    fiscalContractId?: string;
    archivingContractId?: string;
    elsterContractId?: string;
    contractMonth?: string;
    pageSize?: number;
    pageNumber?: number;
    sort?: string;
}

export class ClsGetTenantsRequestParams {
    filter?: string = undefined;
    search?: Array<string> = undefined;
    type?: Array<TenantTypeEnumDTO> = undefined;
    status?: Array<TenantStatusEnumDTO> = undefined;
    tenantGroup?: Array<TenantGroupEnumDTO> = undefined;
    tenantIds?: Array<string> = undefined;
    customerIdentifier?: string = undefined;
    requiredTenantId?: string = undefined;
    fiscalContractId?: string = undefined;
    archivingContractId?: string = undefined;
    elsterContractId?: string = undefined;
    contractMonth?: string = undefined;
    pageSize?: number = undefined;
    pageNumber?: number = undefined;
    sort?: string = undefined;
}

export interface GetTenantsWithInvalidCustomerRequestParams {
    pageSize?: number;
    pageNumber?: number;
    sort?: string;
}

export class ClsGetTenantsWithInvalidCustomerRequestParams {
    pageSize?: number = undefined;
    pageNumber?: number = undefined;
    sort?: string = undefined;
}

export interface UpdateTenantRequestParams {
    tenantId: string;
    ifMatch: string;
    tenantBodyDTO: TenantBodyDTO;
}

export class ClsUpdateTenantRequestParams {
    tenantId: string = undefined;
    ifMatch: string = undefined;
    tenantBodyDTO: TenantBodyDTO = undefined;
}

export interface UpdateTenantElsterConfigRequestParams {
    tenantId: string;
    ifMatch: string;
    elsterConfigurationDTO: ElsterConfigurationDTO;
}

export class ClsUpdateTenantElsterConfigRequestParams {
    tenantId: string = undefined;
    ifMatch: string = undefined;
    elsterConfigurationDTO: ElsterConfigurationDTO = undefined;
}

export interface UpdateTenantStatusRequestParams {
    tenantId: string;
    ifMatch: string;
    tenantStatusDTO: TenantStatusDTO;
}

export class ClsUpdateTenantStatusRequestParams {
    tenantId: string = undefined;
    ifMatch: string = undefined;
    tenantStatusDTO: TenantStatusDTO = undefined;
}

export interface UpdateTenantSystemConfigRequestParams {
    tenantId: string;
    ifMatch: string;
    adminSystemConfigurationBodyDTO: AdminSystemConfigurationBodyDTO;
}

export class ClsUpdateTenantSystemConfigRequestParams {
    tenantId: string = undefined;
    ifMatch: string = undefined;
    adminSystemConfigurationBodyDTO: AdminSystemConfigurationBodyDTO = undefined;
}


export interface AdminTenantsApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Create a new tenant
     * 
* @param requestParameters
     */
    createTenant(requestParameters: CreateTenantRequestParams, extraHttpRequestParams?: any): Observable<TenantDTO>;

    /**
     * Retrieve Tenant
     * Get Tenant detailed information - just only for admin of whole system
* @param requestParameters
     */
    getTenant(requestParameters: GetTenantRequestParams, extraHttpRequestParams?: any): Observable<TenantDTO>;

    /**
     * Retrieve Elster configuration of the tenant.
     * Retrieve Elster configuration of the tenant.
* @param requestParameters
     */
    getTenantElsterConfig(requestParameters: GetTenantElsterConfigRequestParams, extraHttpRequestParams?: any): Observable<ElsterConfigurationDTO>;

    /**
     * Retrieve tenant children list
     * 
* @param requestParameters
     */
    getTenantTenants(requestParameters: GetTenantTenantsRequestParams, extraHttpRequestParams?: any): Observable<TenantsResponseDTO>;

    /**
     * Retrieve list of tenants
     * Get a list of configured tenants - only available for admin users of Fiskal Cloud
* @param requestParameters
     */
    getTenants(requestParameters: GetTenantsRequestParams, extraHttpRequestParams?: any): Observable<TenantsResponseDTO>;

    /**
     * Retrieve a list of tenants which have an invalid customer identifier
     * Retrieve a list of tenants which have an invalid customer identifier. This includes tenants without customer identifier or their custemer identifier has no contract. 
* @param requestParameters
     */
    getTenantsWithInvalidCustomer(requestParameters: GetTenantsWithInvalidCustomerRequestParams, extraHttpRequestParams?: any): Observable<TenantsResponseDTO>;

    /**
     * Update a tenant
     * 
* @param requestParameters
     */
    updateTenant(requestParameters: UpdateTenantRequestParams, extraHttpRequestParams?: any): Observable<TenantDTO>;

    /**
     * Update Elster configuration for tenant.
     * Update Elster configuration for tenant.
* @param requestParameters
     */
    updateTenantElsterConfig(requestParameters: UpdateTenantElsterConfigRequestParams, extraHttpRequestParams?: any): Observable<ElsterConfigurationDTO>;

    /**
     * Update a tenant status
     * 
* @param requestParameters
     */
    updateTenantStatus(requestParameters: UpdateTenantStatusRequestParams, extraHttpRequestParams?: any): Observable<TenantDTO>;

    /**
     * Update the tenant\&#39;s system configuration
     * Update system configuration for the tenant.
* @param requestParameters
     */
    updateTenantSystemConfig(requestParameters: UpdateTenantSystemConfigRequestParams, extraHttpRequestParams?: any): Observable<SystemConfigurationDTO>;

}
